module.exports = __webpack_public_path__ + "img/customize_application.704254c9.svg";